let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1R2DU")).then(() => parcelRequire('iA7sk'));